import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React from 'react'

import type { SxProps, Theme } from '@mui/material/styles'

type HHSectionPlaceholderProps = {
  title?: React.ReactNode
  sx?: SxProps<Theme>
  [key: string]: unknown
}

const HHSectionPlaceholder = ({ title, sx, ...rest }: HHSectionPlaceholderProps) => (
  <Box p={2}>
    <Alert severity="info" sx={{ display: 'flex', alignItems: 'center', ...sx }} {...rest}>
      <Typography fontWeight={400} variant="h6">
        {title}
      </Typography>
    </Alert>
  </Box>
)

export default HHSectionPlaceholder
